// extend
export * from '@cainiaofe/cn-ui-m/es/components/cn-agreement';
